import React from 'react';

/**
 * AeroIcon: the v3 line icons (16px grid, 1.5 stroke, currentColor), the same
 * set the v3 design files draw with (research/v3/make/build.py). Size them
 * with CSS (.aero-icon is 1em square by default).
 */
const PATHS = {
  home: <path d="M2.5 7 8 2.5 13.5 7v6.5h-4v-4h-3v4h-4z" />,
  site: <><rect x="2" y="3" width="12" height="10" rx="2" /><path d="M2 6h12" /></>,
  test: <><circle cx="8" cy="8" r="5.5" /><circle cx="8" cy="8" r="2" /></>,
  plus: <path d="M8 3v10M3 8h10" />,
  search: <><circle cx="7" cy="7" r="4" /><path d="m10 10 3 3" /></>,
  copy: <><rect x="5" y="5" width="8" height="8" rx="1.5" /><path d="M3 10V4a1 1 0 0 1 1-1h6" /></>,
  arrow: <path d="M3 8h10M9 4l4 4-4 4" />,
  // the website's Test step (a test link)
  link: <path d="M7 9.5a2.5 2.5 0 0 0 3.5 0l2-2a2.5 2.5 0 0 0-3.5-3.5l-.6.6M9 6.5a2.5 2.5 0 0 0-3.5 0l-2 2A2.5 2.5 0 0 0 7 12l.6-.6" />,
  right: <path d="m6 3 5 5-5 5" />,
  left: <path d="M10 3 5 8l5 5" />,
  lock: <><rect x="3.5" y="7" width="9" height="6.5" rx="1.5" /><path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2" /></>,
  ext: <path d="M9 3h4v4M13 3 7.5 8.5M12 9.5V13H3V4h3.5" />,
  up: <path d="M8 13.5v-8M4.5 9 8 5.5 11.5 9M3 2.5h10" />,
  play: <path d="m5.5 3.5 7 4.5-7 4.5z" />,
  figma: <path d="M6 2h2v4H6a2 2 0 0 1 0-4zM8 2h2a2 2 0 0 1 0 4H8zM6 6h2v4H6a2 2 0 0 1 0-4zM10 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM6 10h2v2a2 2 0 1 1-2-2z" />,
  prompt: <><rect x="1.5" y="3" width="13" height="10" rx="2" /><path d="m4.5 6.5 2 1.5-2 1.5M8 10h3.5" /></>,
  chart: <path d="M2.5 13.5h11M4.5 11V8M8 11V4.5M11.5 11V6.5" />,
  users: <><circle cx="6" cy="5.5" r="2.5" /><path d="M1.5 13.5a4.5 4.5 0 0 1 9 0M10.5 3.2a2.5 2.5 0 0 1 0 4.6M12.5 9.6a4.5 4.5 0 0 1 2 3.9" /></>,
  menu: <path d="M2.5 4.5h11M2.5 8h11M2.5 11.5h11" />,
  // session review (phase 5)
  pause: <path d="M5.5 3.5v9M10.5 3.5v9" />,
  download: <path d="M8 2.5v8M4.5 7 8 10.5 11.5 7M3 13.5h10" />,
  monitor: <><rect x="1.5" y="2.5" width="13" height="8.5" rx="1.5" /><path d="M5.5 13.5h5M8 11v2.5" /></>,
  clock: <><circle cx="8" cy="8" r="5.5" /><path d="M8 5v3l2 1.5" /></>,
  mic: <><rect x="6" y="1.5" width="4" height="8" rx="2" /><path d="M3.5 7.5a4.5 4.5 0 0 0 9 0M8 12v2.5" /></>,
  micoff: <><path d="M10 7V3.5a2 2 0 0 0-3.7-1M6 6v1.5a2 2 0 0 0 3.2 1.6M3.5 7.5a4.5 4.5 0 0 0 7.4 3.4M12.5 7.5a4.4 4.4 0 0 1-.3 1.6M8 12v2.5M2.5 2.5l11 11" /></>,
  sun: <><circle cx="8" cy="8" r="2.75" /><path d="M8 1.5v1.5M8 13v1.5M1.5 8H3M13 8h1.5M3.4 3.4l1 1M11.6 11.6l1 1M3.4 12.6l1-1M11.6 4.4l1-1" /></>,
  moon: <path d="M13 9.5A5.5 5.5 0 0 1 6.5 3a5.5 5.5 0 1 0 6.5 6.5z" />,
  watch: <><rect x="1.5" y="3" width="13" height="10" rx="2" /><path d="m6.5 6 3.5 2-3.5 2z" /></>,
  read: <path d="M2.5 4h11M2.5 7h11M2.5 10h8M2.5 13h6" />,
  alert: <><circle cx="8" cy="8" r="5.5" /><path d="M8 5v3.5M8 10.75v.25" /></>,
  check: <path d="m3.5 8.5 3 3 6-7" />,
  x: <path d="m4 4 8 8M12 4l-8 8" />,
  expand: <path d="M2.5 6V2.5H6M10 2.5h3.5V6M13.5 10v3.5H10M6 13.5H2.5V10" />,
  trash: <path d="M2.5 4.5h11M6 4.5V3h4v1.5M4 4.5l.7 9h6.6l.7-9" />,
  back: <path d="M7 3.5 2.5 8 7 12.5M2.5 8h11" />,
  down: <path d="M8 2.5v10M4 8.5l4 4 4-4" />,
  // tester flow (phase 6)
  tab: <><rect x="2" y="3.5" width="12" height="9" rx="1.5" /><path d="M2 6.5h12M5 3.5v3" /></>,
  camera: <><rect x="1.5" y="4.5" width="9" height="7" rx="1.5" /><path d="m10.5 7 4-2v6l-4-2" /></>,
  user: <><circle cx="8" cy="5.5" r="2.5" /><path d="M3 13.5a5 5 0 0 1 10 0" /></>,
  minus: <path d="M3.5 8h9" />,
  info: <><circle cx="8" cy="8" r="6" /><path d="M8 7.5v3.5M8 5.2v.1" /></>,
  restart: <><path d="M3 8a5 5 0 1 0 1.5-3.6M3 3v3h3" /></>,
  more: <><circle cx="3.5" cy="8" r="1" /><circle cx="8" cy="8" r="1" /><circle cx="12.5" cy="8" r="1" /></>,
  // states (phase 7b): offline is a cloud with a slash through it
  offline: <><path d="M4.5 12.5h7a2.5 2.5 0 0 0 .6-4.93A4 4 0 0 0 5 6.2 3.2 3.2 0 0 0 4.5 12.5Z" /><path d="m2.5 2.5 11 11" /></>,
  move: <path d="M8 2v12M2 8h12M8 2 6.5 3.5M8 2l1.5 1.5M8 14l-1.5-1.5M8 14l1.5-1.5M2 8l1.5-1.5M2 8l1.5 1.5M14 8l-1.5-1.5M14 8l-1.5 1.5" />,
};

export const AERO_ICON_NAMES = Object.keys(PATHS);

export default function AeroIcon({ name, className = '' }) {
  const p = PATHS[name];
  if (!p) return null;
  return (
    <svg
      className={`aero-icon ${className}`.trim()}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {p}
    </svg>
  );
}
